var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserCirclePlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 22.5C21.1066 22.5 23.625 19.9816 23.625 16.875C23.625 13.7684 21.1066 11.25 18 11.25C14.8934 11.25 12.375 13.7684 12.375 16.875C12.375 19.9816 14.8934 22.5 18 22.5Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.97168 28.037C9.8191 26.3709 11.111 24.9717 12.7045 23.9945C14.2979 23.0173 16.1307 22.5 17.9999 22.5C19.8692 22.5 21.7019 23.0172 23.2954 23.9945C24.8888 24.9717 26.1808 26.3708 27.0282 28.0369",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.75 7.875H31.5",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.125 4.5V11.25",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3331 15.8706C31.7799 18.6839 31.3245 21.5665 30.0322 24.105C28.7398 26.6435 26.6769 28.7076 24.1391 30.0014C21.6013 31.2952 18.719 31.7522 15.9055 31.3069C13.0919 30.8616 10.4916 29.5369 8.47741 27.5226C6.46318 25.5084 5.13845 22.9081 4.69316 20.0946C4.24787 17.281 4.70488 14.3988 5.99867 11.861C7.29246 9.32318 9.35658 7.26022 11.8951 5.96787C14.4336 4.67551 17.3162 4.22013 20.1294 4.66701",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserCirclePlus);
export default __webpack_public_path__ + "static/media/userCirclePlus.d0f4ca0904ec60034e54344dde052a96.svg";
export { ForwardRef as ReactComponent };